import { StreamPushSetting, UpdateChannelPreferenceResponse, UpdateUserParam } from '@@types/Api/Me';
import { UpdateReadSeqParam, UpdateReadSeqResponse } from '@@types/Api/Member';
import { CHANNEL_ID } from '@@types/common';
import { EffectiveFeaturesResponse } from '@@types/EffectiveFeatures';
import MemberResponse from '@@types/Member/Response';
import { AllPreference, Preference } from '@@types/Preference';

import { LOCALE_CODE, URLS } from '~/constants';
import { PreferenceCategory } from '~/constants/member';
import Api2 from '~/stores/providers/Api2';
import { curry } from 'ramda';

class MeApi {
  constructor(private api: Api2) {}

  fetchUser = (): Promise<MemberResponse> => {
    return this.api.resultRequester.get(`${URLS.WAS_API}/members/me`);
  };

  updateUser = (params: UpdateUserParam): Promise<void> => {
    return this.api.contentsRequester.put(`${URLS.WAS_API}/members/me`, params);
  };

  fetchUserPreferences = (): Promise<AllPreference[]> => {
    return this.api.contentsRequester.get(`${URLS.API}/member/preferences`);
  };

  updateUserPreferences = (
    params: Preference<PreferenceCategory, Record<string, unknown>>[]
  ): Promise<Preference<PreferenceCategory, Record<string, unknown>>[]> => {
    return this.api.contentsRequester.post(`${URLS.API}/member/preferences`, params);
  };

  fetchStreamPush = (): Promise<StreamPushSetting> => {
    return this.api.contentsRequester.get(`${URLS.PROJECT_API}/members/settings/stream.push`);
  };

  notifyDefaultLang = (lang: LOCALE_CODE) => {
    return this.api.contentsRequester.get(`${URLS.API}/members/lang`, {
      params: { lang },
    });
  };

  fetchChannelPreferences = (
    channelId: CHANNEL_ID
  ): Promise<Preference<PreferenceCategory, Record<string, unknown>>[]> => {
    return this.api.contentsRequester.cancelGet(`${URLS.API}/channel/${channelId}/preferences`, channelId);
  };

  updateChannelPreferences = curry(
    (
      channelId: CHANNEL_ID,
      preferences: Preference<PreferenceCategory, Record<string, unknown>>[]
    ): Promise<UpdateChannelPreferenceResponse> => {
      return this.api.contentsRequester.post(`${URLS.API}/channel/${channelId}/preferences`, preferences);
    }
  );

  updateReadSeq = ({ channelId, readSeq }: UpdateReadSeqParam): Promise<UpdateReadSeqResponse> => {
    return this.api.contentsRequester.put(`${URLS.API}/channel/${channelId}/member/seq`, { readSeq });
  };

  fetchEffectiveFeatures = (): Promise<EffectiveFeaturesResponse[]> => {
    return this.api.contentsRequester.get(`${URLS.WAS_API}/members/me/effective-features`);
  };
}

export default MeApi;
